<template>
    <div class="brt-swipe-slide">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Slide",

        inject: ['Swipe'],

        mounted () {
            if(this.Swipe.swipe) {
                this.Swipe.swipe.setup();
            }
        }
    }
</script>

<style lang="less">
    .brt-swipe-slide {
        float: left;
        position: relative;
    }
</style>
